<template>
    <!-- 日志列表 -->
    <div>
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="最近登录开始时间" end-placeholder="最近登录结束时间">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-select v-model="params.condition.accounttype" placeholder="账号类型" clearable>
                    <el-option v-for="item in accounttypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.keyword" placeholder="操作账号" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="accounttypename" label="账号类型" align="center" width="150" key="accounttypename" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="loginname" label="操作账号" align="center" width="200" key="loginname" fixed show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.accountname}}</p>
                    <p>{{scope.row.loginname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="moduletypename" label="操作模块" align="center" width="150" key="moduletypename" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="operationtype" label="操作类型" align="center" width="100" key="operationtype" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="datetime" label="操作时间" align="center" width="150" key="datetime" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="ip" label="操作IP" align="center" width="200" key="ip" show-overflow-tooltip :formatter="formatTab">
                <template slot-scope="scope">
                    <p>{{scope.row.ip }}</p>
                    <p>{{scope.row.ipaddress }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="操作内容" align="center" min-width="150" key="content" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getLogList } from '@/api/measApi/systemManage.js'
export default {
  data() {
    return {
      isSelect: false,
      total: 0,
      tableData: [],
      contentLoading: false,
      params: {
        condition: {
          accounttype: '',
          datetimeend: '',
          datetimestart: '',
          keyword: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      accounttypeList: [
        {
          value: 1,
          label: '超级管理员'
        },
        {
          value: 2,
          label: '校区操作员'
        },
        {
          value: 11,
          label: '学员'
        }
      ],
      date: []
    }
  },
  components: {
    TableSort,
    Page
  },
  created() {
    this.getLogList()
  },
  methods: {
    //   获取日志列表
    getLogList() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.params.condition.datetimestart = this.date[0]
        this.params.condition.datetimeend = this.date[1]
      } else {
        this.params.condition.datetimeend = ''
        this.params.condition.datetimestart = ''
      }
      getLogList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.contentLoading = false
          this.total = res.pageinfo.rowcount
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getLogList()
    },
    // 重置
    reset() {
      this.date = []
      this.params = {
        condition: {
          accounttype: '',
          datetimeend: '',
          datetimestart: '',
          keyword: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getLogList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getLogList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getLogList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    }
  }
}
</script>
